import * as React from 'react'
import { useverificationRequest } from './hooks'
import {
  CBadge,
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CDatePicker,
  CRow,
} from '@coreui/react-pro'
import { Divider, Image } from 'antd'
import { RejectModal } from '../atoms/rejectModal'
import { submitApprove } from './model'
import { HistoriesWidget } from '../atoms/history'
import { path } from '../../../libs'
import { CommentList } from '../../../views/widgets/commentList'
import { CommentForm } from '../../../views/widgets/commentForm'
import { CheckCircleOutlined, CloseSquareOutlined } from '@ant-design/icons'
import { DuplicatesWidget } from '../atoms/duplicates'
import { verificationStatus } from '../const'
import { getColorDepositBadge } from '../../../libs/utils'
import { Guard } from '../../../features/session/guard'

type Props = {
  className?: string
}

const getBadge = (status: string) => {
  switch (status) {
    case 'new':
      return 'success'
    case 'false':
      return 'danger'
    case undefined:
    case 'reject':
      return 'danger'
    default:
      return 'primary'
  }
}

export const VerificationDetail = ({ className }: Props) => {
  const [isVisibleModal, setVisibleModal] = React.useState(false)
  const verificationRequest = useverificationRequest()

  let {
    status,
    requestId,
    manager,
    firstName,
    middleName,
    lastName,
    dateOfBirth,
    country,
    city,
    address,
    zip,
    documentType,
    fileNames,
    browserFileNames,
    expirationDate,
    clientId,
  } = verificationRequest

  return (
    <div>
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Client card</strong>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <strong>User ID:</strong>{' '}
              <a
                target="_blank"
                href={path.clients.details(verificationRequest.client.clientId)}
              >
                {' '}
                {verificationRequest.client.clientId}
              </a>
            </CCol>
            <CCol>
              <strong>Full name:</strong> {verificationRequest.client.fullName}
            </CCol>
            <CCol>
              <strong>E-mail:</strong> {verificationRequest.client.email}
            </CCol>
            <CCol className="d-flex align-items-center gap-2">
              <strong>Is verified:</strong>
              {verificationRequest.client.verified ? (
                <CheckCircleOutlined className={'text-success'} />
              ) : (
                <CloseSquareOutlined className={'text-danger'} />
              )}
            </CCol>
            <CCol className="d-flex align-items-center gap-2">
              <strong>Is partner: </strong>
              {verificationRequest.client.partner ? (
                <CheckCircleOutlined className={'text-success'} />
              ) : (
                <CloseSquareOutlined className={'text-danger'} />
              )}
            </CCol>
            <CCol className="d-flex align-items-center gap-2">
              <strong>Is test: </strong>
              {verificationRequest.client.isTest ? (
                <CheckCircleOutlined className={'text-success'} />
              ) : (
                <CloseSquareOutlined className={'text-danger'} />
              )}
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
      <CCol className={className}>
        <CCard className="mb-4">
          <CCardBody>
            <CRow>
              <CCol>
                <CBadge color={getBadge(status)}>{status}</CBadge>
                <CButton
                  color="success"
                  className="ms-2"
                  onClick={() => {
                    submitApprove({
                      requestId,
                      status,
                    })
                  }}
                >
                  Approve
                </CButton>
                {status !==
                  verificationStatus.verificationRequestStatusRejected() && (
                  <CButton
                    color="danger"
                    className="col-3 ms-2"
                    onClick={() => setVisibleModal(true)}
                  >
                    Reject
                  </CButton>
                )}
                <RejectModal
                  isVisible={isVisibleModal}
                  requestId={requestId}
                  onClose={() => setVisibleModal(false)}
                />
                <Divider />
                <div>Rejection reason: {verificationRequest.reason}</div>
                {verificationRequest.previousReason && (
                  <div>
                    Previous Rejection reason:{' '}
                    {verificationRequest.previousReason}
                  </div>
                )}
                <div>Comment: {verificationRequest.comment}</div> <Divider />
                <div>first name: {firstName}</div>
                <div>middle name: {middleName}</div>
                <div>last name: {lastName}</div>
                <div>date of birth: {dateOfBirth}</div>
                <p></p>
                <CRow>
                  <CCol xs={12}>
                    <CCol xs={12} className="mb-2">
                      <p>
                        {country} - {city} - {address} - {zip}
                      </p>
                    </CCol>
                    <CCol xs={12} className="mb-2">
                      <h6 className="text-muted">Document type</h6>
                      <p>{documentType}</p>
                    </CCol>
                    <CCol xs={12} className="mb-2">
                      <div>
                        <CDatePicker
                          date={expirationDate}
                          label="Expiration date"
                          locale="en-US"
                          onDateChange={(date, formatedDate) => {
                            if (formatedDate != null) {
                              expirationDate = formatedDate
                            }
                          }}
                        />
                      </div>
                    </CCol>
                    <CCol xs={6} className="mb-2">
                      <h6 className="text-muted">Has deposit</h6>
                      <CBadge
                        color={getColorDepositBadge(
                          verificationRequest.client.hasDeposit,
                        )}
                      >
                        {verificationRequest.client.hasDeposit
                          ? 'Has deposit'
                          : 'No deposit'}
                      </CBadge>
                    </CCol>
                  </CCol>
                </CRow>
              </CCol>
              <CCol xs={8}>
                <CCol xs={12}>
                  <div className=" d-flex align-items-baseline justify-content-end">
                    <CButton
                      color="secondary"
                      className="me-2"
                      title={'Edit'}
                      href={path.verificationsV2.edit(requestId)}
                    >
                      Edit
                    </CButton>
                  </div>
                  <Divider />
                  {requestId != '' && <DuplicatesWidget clientId={requestId} />}
                  <Divider />
                  {clientId != '' && (
                    <HistoriesWidget
                      clientId={clientId}
                      requestId={verificationRequest.requestId}
                    />
                  )}
                  <Divider />
                  <CCard>
                    <CCardHeader>Profile notes</CCardHeader>
                    <CCardBody>
                      {clientId != '' && (
                        <CommentList entityType="client" entityId={clientId} />
                      )}
                      <CommentForm type="client" entityId={clientId} />
                    </CCardBody>
                  </CCard>
                </CCol>
              </CCol>
              <div className="mt-2">
                <strong>Manager:</strong> {manager?.user?.email}
              </div>
            </CRow>
          </CCardBody>
        </CCard>
        <Guard permission="view_uploaded_image_verification">
          <CRow>
            <CCol xs={12}>
              <h3>Uploaded Documents</h3>
              {browserFileNames?.map((link) => {
                return (
                  <div key={link}>
                    <Image width={400} src={link} />
                  </div>
                )
              })}
              {browserFileNames?.map((link, index) => {
                return (
                  <a key={index} href={link} target="_blank">
                    doc {index}
                  </a>
                )
              })}
            </CCol>
          </CRow>
        </Guard>
      </CCol>
    </div>
  )
}

export const VerificationView = () => {
  return (
    <div>
      <CRow>
        <VerificationDetail></VerificationDetail>
      </CRow>
      <Divider />
      <CRow>
        <CButtonGroup
          role="group"
          aria-label="Basic example"
          className="gap-5 align-items-baseline justify-content-center"
        >
          <CButton color="success" className="col-3">
            Save
          </CButton>
        </CButtonGroup>
      </CRow>
    </div>
  )
}
